module.exports = __webpack_public_path__ + "media/images/entities_logo/sp_aguas_small-44edc7809f4ef27a83b5509303505a7a.png";